const filterUniqueArrayByName = originalArray =>
  originalArray
    .map(current => current.name)
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter(current => originalArray[current])
    .map(current => originalArray[current])

export { filterUniqueArrayByName }
